import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, addDoc, getDocs, doc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { toast } from "react-hot-toast";
import { productsApi } from "../api/productsApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import "../screenstyles/AddProduct.css"

interface Tag {
  id: string;
  name: string;
  imageUrl: string;
}

interface FilterOption {
  id: string;
  name: string;
  nameAr: string;
  isActive: boolean;
  sortOrder: number;
}

interface FilterValue {
  id: string;
  name: string;
  nameAr: string;

  parentId: string | null;
  isLeaf: boolean;

  isActive: boolean;
  sortOrder: number;
}


const AddProduct: React.FC = () => {
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [AgentPrice, setAgentPrice] = useState("0");
  const [rating, setRating] = useState("5.0");
  const [productDescription, setproductDescription] = useState("");
  const [location, setLocation] = useState("المخزن");
  const [image, setImage] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [points, setpoints] = useState("");
  const [Quantity, setQuantity] = useState("1000");
  const [AgentA, setAgentA] = useState("0");
  const [AgentB, setAgentB] = useState("0");
  const [AgentC, setAgentC] = useState("0");
  const [AgentD, setAgentD] = useState("0");
  const [AgentE, setAgentE] = useState("0");
  const [AgentF, setAgentF] = useState("0");
  const [AgentG, setAgentG] = useState("0");
  const [AgentH, setAgentH] = useState("0");
  const [selectedLenses, setSelectedLenses] = useState<string[]>([]);
  const [arabicDescription, setArabicDescription] = useState("0");
  const [englishDescription, setEnglishDescription] = useState("");
  const [kurdishDescription, setKurdishDescription] = useState("0");

  // ✅ الصور الإضافية
  const [extraImages, setExtraImages] = useState<File[]>([]);
  const [extraPreviews, setExtraPreviews] = useState<string[]>([]);

  // 🔹 التاكات (Tags)
  const [tags, setTags] = useState<Tag[]>([]);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  const [filterOptions, setFilterOptions] =
  useState<FilterOption[]>([]);

const [
  filterValuesByOption,
  setFilterValuesByOption,
] = useState<
  Record<string, FilterValue[]>
>({});

const [
  selectedAttributes,
  setSelectedAttributes,
] = useState<
  Record<string, string[]>
>({});


  useEffect(() => {
    const fetchTags = async () => {
      const tagsCollection = collection(db, "tags");
      const tagsSnapshot = await getDocs(tagsCollection);
      const fetchedTags = tagsSnapshot.docs.map((doc) => ({
        id: doc.id, // ✅ تعيين ID بشكل منفصل
        name: doc.data().name, // ✅ تجنب الانتشار العشوائي
        imageUrl: doc.data().ImageUrl,
      }));
      setTags(fetchedTags);
    };

    fetchTags();
  }, []);

  useEffect(() => {
  const fetchFilterOptions = async () => {
    try {
      const optionsSnapshot =
        await getDocs(
          collection(
            db,
            "filterOptions",
          ),
        );

      const fetchedOptions:
        FilterOption[] =
        optionsSnapshot.docs
          .map((filterDoc) => {
            const data =
              filterDoc.data();

            return {
              id:
                filterDoc.id,

              name:
                String(
                  data.name ??
                    "",
                ),

              nameAr:
                String(
                  data.nameAr ??
                    "",
                ),

              isActive:
                data.isActive !==
                false,

              sortOrder:
                typeof data.sortOrder ===
                  "number"
                  ? data.sortOrder
                  : 0,
            };
          })
          .filter(
            (option) =>
              option.isActive,
          )
          .sort(
            (first, second) =>
              first.sortOrder -
              second.sortOrder,
          );

      setFilterOptions(
        fetchedOptions,
      );

      const valuesMap:
        Record<
          string,
          FilterValue[]
        > = {};

      for (
        const filterOption
        of fetchedOptions
      ) {
        const valuesSnapshot =
          await getDocs(
            collection(
              db,
              "filterOptions",
              filterOption.id,
              "values",
            ),
          );

        valuesMap[
          filterOption.id
        ] =
          valuesSnapshot.docs
            .map((valueDoc) => {
              const data =
                valueDoc.data();

              return {
                id:
                  valueDoc.id,

                name:
                  String(
                    data.name ??
                      "",
                  ),

                nameAr:
                  String(
                    data.nameAr ??
                      "",
                  ),

                parentId:
                  typeof data.parentId ===
                    "string" &&
                  data.parentId.trim()
                    ? data.parentId.trim()
                    : null,

                isLeaf:
                  typeof data.isLeaf ===
                    "boolean"
                    ? data.isLeaf
                    : true,

                isActive:
                  data.isActive !==
                  false,

                sortOrder:
                  typeof data.sortOrder ===
                    "number"
                    ? data.sortOrder
                    : 0,
              };
            })
            .filter(
              (value) =>
                value.isActive,
            )
            .sort(
              (first, second) =>
                first.sortOrder -
                second.sortOrder,
            );
      }

      setFilterValuesByOption(
        valuesMap,
      );
    } catch (error) {
      console.error(
        "Error loading filter options:",
        error,
      );

      toast.error(
        "حدث خطأ أثناء تحميل الفلاتر",
      );
    }
  };

  fetchFilterOptions();
}, []);


  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
  };

  // ✅ دالة حذف الصورة من القائمة
  const removeImage = (index: number) => {
    setExtraPreviews((prev) => prev.filter((_, i) => i !== index));
  };
  // 🔹 تحديد التاكات
  const toggleTagSelection = (tagId: string) => {
    setSelectedTags((prevTags) =>
      prevTags.includes(tagId)
        ? prevTags.filter((id) => id !== tagId)
        : [...prevTags, tagId]
    );
  };
const handleAttributeValueToggle = (
  filterOptionId: string,
  valueId: string,
) => {
  const filterValues =
    filterValuesByOption[
      filterOptionId
    ] ?? [];

  const getDescendantIds = (
    parentId: string,
  ): string[] => {
    const directChildren =
      filterValues.filter(
        (value) =>
          value.parentId ===
          parentId,
      );

    return directChildren.flatMap(
      (child) => [
        child.id,
        ...getDescendantIds(
          child.id,
        ),
      ],
    );
  };

  setSelectedAttributes(
    (prev) => {
      const currentValues =
        prev[
          filterOptionId
        ] ?? [];

      const isSelected =
        currentValues.includes(
          valueId,
        );

      if (isSelected) {
        const descendantIds =
          getDescendantIds(
            valueId,
          );

        const idsToRemove =
          new Set([
            valueId,
            ...descendantIds,
          ]);

        return {
          ...prev,

          [filterOptionId]:
            currentValues.filter(
              (id) =>
                !idsToRemove.has(
                  id,
                ),
            ),
        };
      }

      return {
        ...prev,

        [filterOptionId]: [
          ...currentValues,
          valueId,
        ],
      };
    },
  );
};



  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (
      arabicDescription.trim() === "" ||
      englishDescription.trim() === "" ||
      kurdishDescription.trim() === "" ||
      code.trim() === "" ||
      name.trim() === "" ||
      price.trim() === "" ||
      AgentPrice.trim() === "" ||
      rating.trim() === "" ||
      location.trim() === "" ||
      points.trim() === "" ||
      Quantity.trim() === "" ||
      !image ||
      selectedTags.length === 0
    ) {
      toast.error(
        "❌ يرجى ملء جميع الحقول المطلوبة، بما في ذلك اختيار التاكات!",
        {
          duration: 3000,
          position: "top-right",
          style: {
            background:
              "linear-gradient(to top, rgb(10, 113, 132), rgb(38, 55, 180))",
            color: "#fff",
            fontSize: "16px",
          },
        }
      );
      return;
    }

    setLoading(true);
    try {
      const storage = getStorage();

      // ✅ رفع الصورة الأساسية
      const imageRef = ref(storage, `product-images/${image.name}`);
      await uploadBytes(imageRef, image);
      const imageUrl = await getDownloadURL(imageRef);

      // ✅ إضافة المنتج إلى كولكشن `product`
    const createResult =
  await productsApi.create({
    code,

    name,

    price:
      Number(price),

    AgentPrice:
      Number(AgentPrice),

    rating:
      Number(rating),

    productDescription:
      englishDescription,

    location,

    points:
      Number(points),

    quantity:
      Number(Quantity),

    Quantity:
      Number(Quantity),

    imageUrl,

    AgentA:
      Number(AgentA),

    AgentB:
      Number(AgentB),

    AgentC:
      Number(AgentC),

    AgentD:
      Number(AgentD),

    AgentE:
      Number(AgentE),

    AgentF:
      Number(AgentF),

    AgentG:
      Number(AgentG),

    AgentH:
      Number(AgentH),

    tags:
      selectedTags,

    attributes:
      selectedAttributes,
  });

const productId =
  createResult.item.id;

      // ✅ إضافة العدسات المختارة في كولكشن ayes
      for (const lens of selectedLenses) {
        await addDoc(collection(db, "product", productId, "ayes"), {
          name: lens,
        });
      }

      // إضافة أو تحديث كولكشن فرعي Language مع 3 مستندات للغات
      // إضافة أو تحديث كولكشن فرعي Language مع 3 مستندات آيدي أوتوجينريتد
      await addDoc(collection(db, "product", productId, "Language"), {
        Language: "ar",
        productDescription: arabicDescription,
      });

      await addDoc(collection(db, "product",productId, "Language"), {
        Language: "en",
        productDescription: englishDescription,
      });

      await addDoc(collection(db, "product", productId, "Language"), {
        Language: "ku",
        productDescription: kurdishDescription,
      });

      // for (const tagId of selectedTags) {
      //   await setDoc(doc(db, "product", productRef.id, "tags", tagId), {}); // إضافة مستند فارغ
      // }

      // ✅ رفع الصور الإضافية إلى `productImages`
      for (const extraImage of extraImages) {
        const imageId = doc(
          collection(db, "product", productId, "productImages")
        ).id;
        const extraImageRef = ref(
          storage,
          `product-images/${productId}/${imageId}.jpg`
        );
        await uploadBytes(extraImageRef, extraImage);
        const extraImageUrl = await getDownloadURL(extraImageRef);

        await setDoc(
          doc(db, "product", productId, "productImages", imageId),
          {
            imageUrl: extraImageUrl,
          }
        );
      }

      toast.success("✅ تم إضافة المنتج والصور بنجاح!", {
        duration: 3000,
        position: "top-right",
        style: {
          background:
            "linear-gradient(to top, rgb(25, 113, 132), rgb(38, 155, 180))",
          color: "#fff",
          fontSize: "16px",
        },
      });

      // ✅ إعادة تعيين القيم بعد الإضافة
      setCode("");
      setName("");
      setPrice("");
      setAgentPrice("0");
      setRating("5.0");
      setproductDescription("");
      setLocation("المخزن");
      setpoints("");
      setQuantity("1000");
      setImage(null);
      setPreview(null);
      setExtraImages([]);
      setExtraPreviews([]);
      setSelectedTags([]);
      setSelectedAttributes({});
      setAgentA("0");
      setAgentB("0");
      setAgentC("0");
      setAgentD("0");
      setAgentE("0");
      setAgentF("0");
      setAgentG("0");
      setAgentH("0");
      setArabicDescription("0");
      setEnglishDescription("");
      setKurdishDescription("0");
    } catch (error) {
      console.error("❌ خطأ في إضافة المنتج:", error);
      toast.error("⚠️ فشل في إضافة المنتج، يرجى المحاولة مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  const resetFields = () => {
    setCode("");
    setName("");
    setPrice("");
    setAgentPrice("0");
    setRating("");
    setproductDescription("");
    setLocation("");
    setpoints("");
    setQuantity("");
    setImage(null);
    setPreview(null);
    setExtraImages([]);
    setExtraPreviews([]);
    setSelectedTags([]);
    setSelectedAttributes({});
    setAgentA("");
    setAgentB("");
    setAgentC("");
    setAgentD("");
    setAgentE("");
    setAgentF("");
    setAgentG("");
    setAgentH("");
    toast.success("تم مسح جميع الحقول بنجاح!", {
      duration: 2000,
      position: "top-right",
    });
  };
  // ✅ اختيار صور إضافية
  const handleExtraImagesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setExtraImages(files);

      // عرض المعاينة للصور المختارة
      const previews = files.map((file) => URL.createObjectURL(file));
      setExtraPreviews(previews);
    }
  };

return (
  <div className="add-product-page">
    <div className="add-product-header">
      <h1 className="add-product-title">إضافة منتج جديد</h1>

      <button
        type="button"
        className="add-product-header-btn add-product-reset-btn"
        onClick={resetFields}
        title="مسح الحقول"
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>

      <button
        type="button"
        className="add-product-header-btn"
        onClick={() => navigate(-1)}
        title="رجوع"
      >
        <FontAwesomeIcon icon={faArrowLeft} />
      </button>
    </div>

    <form onSubmit={handleSubmit} className="add-product-form">
      <div className="add-product-field">
        <label className="add-product-label">كود المنتج:</label>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">اسم المنتج:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">نقاط المنتج:</label>
        <input
          type="text"
          value={points}
          onChange={(e) => setpoints(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">موقع خزن المنتج:</label>
        <input
          type="text"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">السعر:</label>
        <input
          type="text"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
          className="add-product-input"
        />
      </div>


<div className="add-product-field">
  <label className="add-product-label">سعر DPP:</label>
  <input
    type="text"
    value={AgentPrice}
    onChange={(e) => setAgentPrice(e.target.value)}
    required
    className="add-product-input"
  />
</div>
      <div className="add-product-field">
        <label className="add-product-label">التقييم:</label>
        <input
          type="text"
          value={rating}
          onChange={(e) => setRating(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">الكمية:</label>
        <input
          type="text"
          value={Quantity}
          onChange={(e) => setQuantity(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">النقاط A:</label>
        <input
          type="text"
          value={AgentA}
          onChange={(e) => setAgentA(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">النقاط B:</label>
        <input
          type="text"
          value={AgentB}
          onChange={(e) => setAgentB(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">النقاط C:</label>
        <input
          type="text"
          value={AgentC}
          onChange={(e) => setAgentC(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">النقاط D:</label>
        <input
          type="text"
          value={AgentD}
          onChange={(e) => setAgentD(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">النقاط E:</label>
        <input
          type="text"
          value={AgentE}
          onChange={(e) => setAgentE(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">النقاط F:</label>
        <input
          type="text"
          value={AgentF}
          onChange={(e) => setAgentF(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">النقاط G:</label>
        <input
          type="text"
          value={AgentG}
          onChange={(e) => setAgentG(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field">
        <label className="add-product-label">النقاط H:</label>
        <input
          type="text"
          value={AgentH}
          onChange={(e) => setAgentH(e.target.value)}
          required
          className="add-product-input"
        />
      </div>

      <div className="add-product-field add-product-full">
        <label className="add-product-label">الوصف بالعربية:</label>
        <textarea
          value={arabicDescription}
          onChange={(e) => setArabicDescription(e.target.value)}
          required
          className="add-product-textarea"
        />
      </div>

      <div className="add-product-field add-product-full">
        <label className="add-product-label">الوصف بالإنكليزية:</label>
        <textarea
          value={englishDescription}
          onChange={(e) => setEnglishDescription(e.target.value)}
          required
          className="add-product-textarea"
        />
      </div>

      <div className="add-product-field add-product-full">
        <label className="add-product-label">الوصف بالكردية:</label>
        <textarea
          value={kurdishDescription}
          onChange={(e) => setKurdishDescription(e.target.value)}
          required
          className="add-product-textarea"
        />
      </div>

<div className="add-product-section add-product-full">
  <h3 className="add-product-section-title">
    الفلاتر:
  </h3>

  {filterOptions.map(
    (filterOption) => {
      const filterValues =
        filterValuesByOption[
          filterOption.id
        ] ?? [];

      const selectedValues =
        selectedAttributes[
          filterOption.id
        ] ?? [];

      const rootValues =
        filterValues.filter(
          (value) =>
            !value.parentId,
        );

      const selectedParents =
        filterValues.filter(
          (value) =>
            selectedValues.includes(
              value.id,
            ) &&
            filterValues.some(
              (child) =>
                child.parentId ===
                value.id,
            ),
        );

      return (
        <div
          key={filterOption.id}
          className="add-product-filter-group"
        >
          <h4 className="add-product-section-title">
            {filterOption.nameAr ||
              filterOption.name}
          </h4>

          {/* المستوى الأول */}
          <div className="add-product-filter-level">
            <div className="add-product-filter-level-title">
              اختر القيمة:
            </div>

            <div className="add-product-checkboxes">
              {rootValues.map(
                (value) => {
                  const isSelected =
                    selectedValues.includes(
                      value.id,
                    );

                  const hasChildren =
                    filterValues.some(
                      (child) =>
                        child.parentId ===
                        value.id,
                    );

                  return (
                    <label
                      key={value.id}
                      className={
                        isSelected
                          ? "add-product-checkbox-label add-product-checkbox-label-selected"
                          : "add-product-checkbox-label"
                      }
                    >
                      <input
                        type="checkbox"
                        checked={
                          isSelected
                        }
                        onChange={() =>
                          handleAttributeValueToggle(
                            filterOption.id,
                            value.id,
                          )
                        }
                      />

                      <span>
                        {value.nameAr ||
                          value.name}

                        {hasChildren && (
                          <small className="add-product-filter-has-children">
                            يحتوي خيارات
                          </small>
                        )}
                      </span>
                    </label>
                  );
                },
              )}
            </div>
          </div>

          {/* المستويات التي تظهر حسب الاختيار */}
          {selectedParents.map(
            (parent) => {
              const children =
                filterValues.filter(
                  (value) =>
                    value.parentId ===
                    parent.id,
                );

              if (
                children.length === 0
              ) {
                return null;
              }

              return (
                <div
                  key={parent.id}
                  className="add-product-filter-level"
                >
                  <div className="add-product-filter-level-title">
                    الخيارات داخل{" "}
                    <strong>
                      {parent.nameAr ||
                        parent.name}
                    </strong>
                    :
                  </div>

                  <div className="add-product-checkboxes">
                    {children.map(
                      (value) => {
                        const isSelected =
                          selectedValues.includes(
                            value.id,
                          );

                        const hasChildren =
                          filterValues.some(
                            (child) =>
                              child.parentId ===
                              value.id,
                          );

                        return (
                          <label
                            key={value.id}
                            className={
                              isSelected
                                ? "add-product-checkbox-label add-product-checkbox-label-selected"
                                : "add-product-checkbox-label"
                            }
                          >
                            <input
                              type="checkbox"
                              checked={
                                isSelected
                              }
                              onChange={() =>
                                handleAttributeValueToggle(
                                  filterOption.id,
                                  value.id,
                                )
                              }
                            />

                            <span>
                              {value.nameAr ||
                                value.name}

                              {hasChildren && (
                                <small className="add-product-filter-has-children">
                                  يحتوي خيارات
                                </small>
                              )}
                            </span>
                          </label>
                        );
                      },
                    )}
                  </div>
                </div>
              );
            },
          )}
        </div>
      );
    },
  )}
</div>

      <div className="add-product-section add-product-full">
        <h3 className="add-product-section-title">
          اختر العدسات (يمكن اختيار أكثر من واحدة):
        </h3>

        <div className="add-product-checkboxes">
          {["2.8", "3.6", "4.0", "6.0"].map((lens) => (
            <label key={lens} className="add-product-checkbox-label">
              <input
                type="checkbox"
                checked={selectedLenses.includes(lens)}
                onChange={() =>
                  setSelectedLenses((prev) =>
                    prev.includes(lens)
                      ? prev.filter((l) => l !== lens)
                      : [...prev, lens]
                  )
                }
              />
              <span>{lens} mm</span>
            </label>
          ))}
        </div>
      </div>

      <div className="add-product-section add-product-full">
        <label className="add-product-section-title">الصورة الرئيسية:</label>

        <div className="add-product-image-panel">
          <label className="add-product-file-btn">
            اختر صورة
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="add-product-hidden-input"
            />
          </label>

          {preview && (
            <div className="add-product-main-preview-box">
              <span className="add-product-preview-title">
                الصورة المختارة:
              </span>

              <img
                src={preview}
                alt="معاينة الصورة"
                className="add-product-main-preview"
              />
            </div>
          )}
        </div>
      </div>

      <div className="add-product-section add-product-full">
        <h3 className="add-product-section-title">اختر التاكات:</h3>

        <div className="add-product-tags-box">
          <div className="add-product-tags-grid">
            {tags.map((tag) => (
              <div
                key={tag.id}
                className={
                  selectedTags.includes(tag.id)
                    ? "add-product-tag-item add-product-tag-item-selected"
                    : "add-product-tag-item"
                }
                onClick={() => toggleTagSelection(tag.id)}
              >
                <img
                  src={tag.imageUrl}
                  alt={tag.name}
                  className="add-product-tag-image"
                />

                <span
                  className={
                    selectedTags.includes(tag.id)
                      ? "add-product-tag-name add-product-tag-name-selected"
                      : "add-product-tag-name"
                  }
                >
                  {tag.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="add-product-section add-product-full">
        <label className="add-product-section-title">صور إضافية:</label>

        <label className="add-product-file-btn add-product-file-btn-full">
          <span>اختر صور</span>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleExtraImagesChange}
            className="add-product-hidden-input"
          />
        </label>

        {extraPreviews.length > 0 && (
          <div className="add-product-extra-preview-grid">
            {extraPreviews.map((preview, index) => (
              <div key={index} className="add-product-extra-image-card">
                <img
                  src={preview}
                  alt={`صورة إضافية ${index + 1}`}
                  className="add-product-extra-image"
                />

                <button
                  type="button"
                  onClick={() => removeImage(index)}
                  className="add-product-remove-image-btn"
                >
                  <FontAwesomeIcon icon={faTrash} size="sm" />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="add-product-actions">
        <button
          type="submit"
          disabled={loading}
          className="add-product-submit-btn"
        >
          {loading ? "جاري الإضافة..." : "إضافة المنتج"}
        </button>
      </div>
    </form>
  </div>
);

};

export default AddProduct;
